import { BoardStatKeys, BoardStats, ConfettiMode, GamePhase, WarStatus } from '../../app/types';
import { GameEngine } from '../game-engine-helper';
import { SFSObject } from 'sfs2x-api';
import { SFSVAR } from '../sfsVar';
import { bwar_duel, bwar_home } from '../../env';
import {
    claimButton,
    concedeButton,
    continueButton, leaderBoardButton,
    nextHandButton,
    pickBattleButton,
    undoButton,
} from '../buttonsState';
import { closeBWarWindow } from '../../utils/mixed';
import { getEndOfDailyDuelMessage, getEndOfDailyDuelShareFrame, getEndOfWarMessage } from '../../utils/shark-helper';
import { modalGameResults } from '../../utils/modal.helper';
import { t } from 'i18next';

export function MID_TIME_TO_SCORE(cmdObj: SFSObject, sender: GameEngine) {
    return;
}

export async function MID_TIME_TO_SCORE_SB(cmdObj: SFSObject, sender: GameEngine) {
    sender.hideButtons([claimButton, concedeButton, undoButton]);
    sender.props.table_setAuxiliaryMessage({ position: 'center', message: undefined });
    sender.props.table_setAuxiliaryMessage({ position: 'right', message: undefined });
    sender.props.table_setAuxiliaryMessage({ position: 'left', message: undefined });
    sender.props.table_setGamePhase(GamePhase.END);

    const oblState: SFSObject | undefined = cmdObj.containsKey('oplay') ? cmdObj.getSFSObject('oplay') : undefined;
    if (oblState) {
        sender.setHandsFromScore(oblState, true, 'h');
    }
    const nsTricks: number = cmdObj.containsKey('nstr')
        ? cmdObj.getInt('nstr')
        : oblState?.containsKey('nstr')
        ? oblState.getInt('nstr')
        : 0;
    const ewTricks: number = cmdObj.containsKey('ewtr')
        ? cmdObj.getInt('ewtr')
        : oblState?.containsKey('ewtr')
        ? oblState.getInt('ewtr')
        : 0;

    sender.props.table_setTrickCounts({ ns: nsTricks, ew: ewTricks });
    const score: number = cmdObj.getInt(SFSVAR.SFSGAME_MID_LOAD);


    if (!sender.props.app.engineStateInterface.isMiniBridge) {
        sender.props.table_setShowAuctionLine(true);
    }
    //
    try {
        if (cmdObj.containsKey('stats')) {
            const json = new TextDecoder('utf-8').decode(cmdObj.getByteArray('stats'));
            const boardStats: BoardStats[] = JSON.parse(json) as BoardStats[];
            sender.props.table_setBoardStats(boardStats);
            if (cmdObj.containsKey('mystat')) {
                const myStatsKey = JSON.parse(
                    new TextDecoder('utf-8').decode(cmdObj.getByteArray('mystat')),
                ) as BoardStatKeys;
                if (myStatsKey) {
                    sender.props.table_setMyBoardStatKeys(myStatsKey);
                }
            } else {
                sender.props.table_setMyBoardStatKeys({} as BoardStatKeys);
            }
        } else {
            sender.props.table_setBoardStats([]);
            sender.props.table_setMyBoardStatKeys({} as BoardStatKeys);
        }
    } catch (e) {
        //
    }

    try {
        if (cmdObj.containsKey('board')) {
            const json = new TextDecoder('utf-8').decode(cmdObj.getByteArray('board'));
            const boardStats: BoardStats[] = JSON.parse(json) as BoardStats[];
           // sender.props.table_setBoardStats(boardStats);

        } else {
            sender.props.table_setBoardStats([]);
            sender.props.table_setMyBoardStatKeys({} as BoardStatKeys);
        }
    } catch (e) {
        //
    }

    const delay = () => new Promise((resolve) => setTimeout(resolve, 0));
    await delay();

    sender.updateBoardData(undefined);

    if (sender.props.app.engineStateInterface.isInstaGame) {
        sender.props.table_setWalkThroughShowComponents(['sharkInstaBoardReviewComponent'])
        sender.props.table_setWalkTrough({ content: `` });
    }else {
        sender.props.table_setWalkThroughShowComponents(['sharkBoardReviewComponent'])
        sender.props.table_setWalkTrough({ content: `Your Score: ${score}` });
    }

    if (sender.props.app.engineStateInterface.hasNext) {
        sender.showButtons([nextHandButton]);
    }
    else {
        sender.showButtons([leaderBoardButton]);
    }
}

export async function MID_TIME_TO_SCORE_BWAR(cmdObj: SFSObject, sender: GameEngine) {
    const delay = () => new Promise((resolve) => setTimeout(resolve, 0));
    await delay();
    sender.hideButtons([claimButton, concedeButton, undoButton]);
    sender.props.table_setAuxiliaryMessage({ position: 'center', message: undefined });
    sender.props.table_setAuxiliaryMessage({ position: 'right', message: undefined });
    sender.props.table_setAuxiliaryMessage({ position: 'left', message: undefined });
    sender.props.table_setGamePhase(GamePhase.END);
    sender.props.table_setShowAuctionLine(false);
    const oblState: SFSObject | undefined = cmdObj.containsKey('oplay') ? cmdObj.getSFSObject('oplay') : undefined;
    if (oblState) {
        sender.setHandsFromScore(oblState, true, 'h');
    }
    const nsTricks: number = cmdObj.containsKey('nstr') ? cmdObj.getInt('nstr') : oblState?.containsKey('nstr') ? oblState.getInt('nstr') : 0;
    const ewTricks: number = cmdObj.containsKey('ewtr') ? cmdObj.getInt('ewtr') : oblState?.containsKey('ewtr') ? oblState.getInt('ewtr') : 0;

    sender.props.table_setTrickCounts({ ns: nsTricks, ew: ewTricks });
    //sender.props.table_setWalkTrough({ content: `You took ${nsTricks} ${nsTricks === 1 ? 'trick' : 'tricks'}` });

    try {
        if (cmdObj.containsKey('stats')) {
            const json = new TextDecoder('utf-8').decode(cmdObj.getByteArray('stats'));
            const boardStats: BoardStats[] = JSON.parse(json) as BoardStats[];
            sender.props.table_setBoardStats(boardStats);
            if (cmdObj.containsKey('mystat')) {
                const myStatsKey: BoardStatKeys = JSON.parse(
                    new TextDecoder('utf-8').decode(cmdObj.getByteArray('mystat')),
                ) as BoardStatKeys;
                sender.props.table_setMyBoardStatKeys(myStatsKey);
            } else {
                sender.props.table_setMyBoardStatKeys({} as BoardStatKeys);
            }
        } else {
            sender.props.table_setBoardStats([]);
            sender.props.table_setMyBoardStatKeys({} as BoardStatKeys);
        }
    }
    catch (e) {
        //
    }

    if (sender.props.app.engineStateInterface.hasNext) {
        sender.showButtons([nextHandButton]);
    } else {
        sender.showButtons([continueButton]);
    }

    sender.updateBoardData(undefined);
    const myresults = cmdObj.getSFSObject('myresults');
    console.log('myresults', myresults.getDump());

    const war_record = myresults.getSFSArray('war_record');
    const topResult = war_record.getSFSObject(3).getInt('pts');
    const war_status: WarStatus | undefined = myresults.containsKey('war_status') ? myresults.getUtfString('war_status') as WarStatus : undefined;
    const isEndOfWar = war_status !== WarStatus.progress && war_status !== undefined;

    const battles = myresults.getSFSArray('battles');
    const currentBattle = battles.getSFSObject(battles.size() - 1);
    const battleStatus = currentBattle.getUtfString('status');
    const endOfBattle = battleStatus !== WarStatus.progress && battleStatus !== undefined;

    const duels = currentBattle.getSFSArray('duels');
    const lastDuel = duels.getSFSObject(duels.size() - 1);
    const duelGoal = lastDuel.getInt('g');
    const duelPlayed = duels.size();
    const duelsWon = currentBattle.getInt('wins');
    const isDailyDuel = battles.size() === 1;


    let confettiMode: ConfettiMode | undefined = undefined;
    let battleDisplay: string;
    let battleHeader = 'Victory!';

    if (isEndOfWar) {
        battleHeader = t(`warEndHeaders.${war_status}.${isDailyDuel}`);
        battleDisplay = t(`warEndBlurb.${war_status}.${isDailyDuel}`,{nsTricks});
        switch (war_status) {
            case WarStatus.topWin:
                confettiMode = ConfettiMode.warBigWin;
                break;
            case WarStatus.goodWin:
                confettiMode = ConfettiMode.warSmallWin;
                break;
            case WarStatus.win:
                confettiMode = ConfettiMode.battleSmallWin;
                break;
            case WarStatus.loss:
                confettiMode = ConfettiMode.warLoss;
                break;
            case WarStatus.draw:
                confettiMode = ConfettiMode.warDraw;
                break;
        }
    }else if (endOfBattle){
        battleDisplay = t(`warEndBlurb.${battleStatus}.${isDailyDuel}`,{nsTricks});
    }

    const resultWin = war_record ? war_record.getInt(0) : 0;
    const resultLoss = war_record ? war_record.getInt(1) : 0;
    const resultDraw = war_record ? war_record.getInt(2) : 0;

    const duelRecord = `</br>Duel Record </br> ${duelsWon} - ${duelPlayed - duelsWon}`;
    const trickMessage = `You took ${nsTricks} ${nsTricks === 1 ? 'trick' : 'tricks'}`;
    const battleRecord = `</br>Battle Record </br> ${resultWin} - ${resultLoss} - ${resultDraw}`;
    const endOfBattleMessage = `${battleDisplay} </br>${trickMessage}</br>${duelRecord}</br>${battleRecord}`;

    if (isEndOfWar) {
        //We are at the end of the War adjust the message and show modal.
        sender.props.table_updateFooterButtons([{ key: 'button-4', button: pickBattleButton }]);
        sender.props.app_addModal(
            battles.size() === 1
                ? getEndOfDailyDuelMessage(
                      confettiMode,
                      `${t(`warEndBlurb.${war_status}.${isDailyDuel}`)} 
                                         </br>
                 ${trickMessage}
                                        </br>
                 ${t(`warLegendBlurb.${war_status}.${isDailyDuel}`, { topResult })}`,
                      battleHeader,
                      {
                          cancelLabel: 'Keep Playing Now',
                          okLabel: 'Share',
                          cancel: () => {
                              parent.location.href = bwar_home;
                          },
                          confirm: () => {
                              // no confirm button.
                              sender.props.app_removeModal();
                              sender.props.app_addModal(getEndOfDailyDuelShareFrame());
                          },
                      },
                  )
                : getEndOfWarMessage(confettiMode, endOfBattleMessage, battleHeader, {
                      cancelLabel: 'Home Base',
                      okLabel: 'War Review',
                      cancel: () => {
                          parent.postMessage('reloaddash', '*');
                          parent.location.href = sender.returnURL;
                      },
                      confirm: () => {
                          const _modalGameResults = modalGameResults({
                              gameResults: sender.props.table.sharkGameResultsV2,
                              noCancel: false,
                              noClickOutside: true,
                              fullSize: true,
                          });
                          sender.props.app_addModal(_modalGameResults);
                      },
                  }),
        );
        return;
    }
    else if (endOfBattle) {
        battleHeader = t(`battleEndHeaders.${battleStatus}.${isDailyDuel}`);
        switch (battleStatus) {
            case WarStatus.topWin:
                confettiMode = ConfettiMode.battleBigWin;
                break;
            case WarStatus.goodWin:
                confettiMode = ConfettiMode.battleSmallWin;
                break;
            case WarStatus.win:
                confettiMode = ConfettiMode.battleSmallWin
                break;
            case WarStatus.loss:
                confettiMode = ConfettiMode.battleLoss
                break;
        }
        //We are at the end of the battle adjust the message and show modal.
        sender.props.app_addModal(
            getEndOfWarMessage(confettiMode, endOfBattleMessage, battleHeader, {
                cancelLabel: 'Home Base',
                okLabel: 'Next Battle',
                cancel: () => {
                    parent.postMessage('reloaddash', '*');
                    parent.location.href = sender.returnURL;
                },
                confirm: () => {
                    sender.clientRequestsNextHand();
                },
            }),
        );
        return;
    }

    let duelHeader = '';
    let m = '';
    if (lastDuel.getInt('s') > 0) {
        confettiMode = ConfettiMode.duelWin;
        duelHeader = 'Glory is Yours';
        m = 'To the victor goes the spoils!';
    }
    else {
        confettiMode = ConfettiMode.duelLoss;
        duelHeader = 'Bested';
        m = 'But your courage is unshaken';
    }
    const displayMessage = `${m} </br>${trickMessage}</br>${duelRecord}</br>${battleRecord}`;
    sender.props.app_addModal(
        getEndOfWarMessage(confettiMode, displayMessage, duelHeader, {
            cancelLabel: 'Home Base',
            okLabel: 'Next Duel',
            cancel: () => {
                parent.postMessage('reloaddash', '*');
                parent.location.href = sender.returnURL;
            },
            confirm: () => {
                sender.clientRequestsNextHand();
            },
        }),
    );
    return;
}


